import { useQueryClient } from "@tanstack/react-query";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import httpClient from "../api/axios";

const LANGUAGE_KEY = "GOALNGO_CURRENT_LANG";

const useLanguageToggle = () => {
  const { i18n } = useTranslation();
  const queryClient = useQueryClient();

  const initialLang = localStorage.getItem(LANGUAGE_KEY) || "en";
  const [currentLang, setCurrentLang] = useState<string>(initialLang);

  const toggleLanguage = () => {
    setCurrentLang((prevLang) => (prevLang === "en" ? "ar" : "en"));
  };

  const setDefaultLanguage = () => {
    setCurrentLang("en");
  };

  useEffect(() => {
    document.documentElement.dir = currentLang === "ar" ? "rtl" : "ltr";

    i18n.changeLanguage(currentLang);
    localStorage.setItem(LANGUAGE_KEY, currentLang);

    const requestInterceptor = httpClient.interceptors.request.use((config) => {
      if (config.headers) config.headers["accept-language"] = currentLang;
      return config;
    });

    // queryClient.invalidateQueries();

    return () => {
      httpClient.interceptors.request.eject(requestInterceptor);
    };
  }, [currentLang]);

  return { currentLang, toggleLanguage, setDefaultLanguage };
};

export default useLanguageToggle;
